import { render, staticRenderFns } from "./AppSettings.vue?vue&type=template&id=e83d6bb2&scoped=true"
import script from "./AppSettings.vue?vue&type=script&lang=js"
export * from "./AppSettings.vue?vue&type=script&lang=js"
import style0 from "./AppSettings.vue?vue&type=style&index=0&id=e83d6bb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e83d6bb2",
  null
  
)

export default component.exports